import request from '@/utils/request'

const articleURL = {
  Created: '/article/create',
  Detail: '/article/view',
  List: '/article/list',
  Delete: '/article/delete',
  Update: '/article/update',
  UpdateState: '/article/update-status',
  ForbiddenWords: '/article/check-forbidden-words'
}

// 创建文章
export function createArticle (data) {
  return request({
    url: articleURL.Created,
    method: 'post',
    data
  })
}

// 文章详情
export function detailArticle (data) {
  return request({
    url: articleURL.Detail,
    method: 'post',
    data
  })
}

// 文章列表
export function listArticle (data) {
  return request({
    url: articleURL.List,
    method: 'post',
    data
  })
}

// 删除文章
export function deleteArticle (data) {
  return request({
    url: articleURL.Delete,
    method: 'post',
    data
  })
}

// 更新文章
export function updateArticle (data) {
  return request({
    url: articleURL.Update,
    method: 'post',
    data
  })
}

// 更新文章状态
export function updateCheckArticle (data) {
  return request({
    url: articleURL.UpdateState,
    method: 'post',
    data
  })
}

// 文章违禁词
export function forbiddenWordsArticle (data) {
  return request({
    url: articleURL.ForbiddenWords,
    method: 'post',
    data
  })
}

export default {
  createArticle,
  detailArticle,
  listArticle,
  deleteArticle,
  updateArticle,
  updateCheckArticle,
  forbiddenWordsArticle
}
